import { useState } from "react";
import Cookie from "../components/Cookie";
import Footer from "../components/Footer";
import Header from "../components/Header";

const Policy = () => {
    const [ tab, setTab ] = useState('cookie')
  return (
    <div>
      <div>
        <Header />
        <section className="relative">
          <div className="container">
            <div className="w-full">
              <img
                src={require("../assets/images/background2.jpg")}
                alt="contact-us"
                className="absolute w-full right-0 left-0 h-full"
              />
              <div  
                className="pointer-events-none absolute left-0 top-0 h-full w-full"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(17, 23, 41, 0.6) 0%, rgba(32, 41, 58, 0.1) 100%)",
                }}
              ></div>
              <div className="relative flex min-h-[27rem] items-center md:min-h-[25.5rem]">
                <div className="items-left flex w-full flex-col">
                <h1 className="uppercase font-oswald break-words text-4xl md:text-5xl font-medium mb-4 text-white text-left">POLICIES &amp; CERTIFICATES</h1>
                <p className="font-poppins break-words text-xl md:text-2xl font-normal max-w-[68.5rem] text-white text-left">Legal information and resources</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <main className="mx-auto mb-16 mt-16 flex w-full max-w-[82.5rem] flex-col px-6 md:mb-24 md:mt-24 md:flex-row xl:px-0">
          <aside className="order-1 mt-16 md:mt-0 md:w-[26.5rem] md:shrink-0">
            <ul>
              <li className="py-3 pr-6 font-bold">Policies</li>
              <ul>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('cookie')}
                    className="text-blue-600"
                  >
                    Cookies policy
                  </a>
                </li>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('code')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    Code of conduct
                  </a>
                </li>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('data')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    Data processing agreement
                  </a>
                </li>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('terms')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    Nyirendas terms of service
                  </a>
                </li>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('policy')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    Recruitment data policy
                  </a>
                </li>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('intergrated')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    Integrated management system policy
                  </a>
                </li>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('warranty')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    Warranty &amp; repair
                  </a>
                </li>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('privacy')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    Privacy policy
                  </a>
                </li>
              </ul>
              <li className="py-3 pr-6 font-bold">Certificates</li>
              <ul>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('quality')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    ISO 9001:2015 Quality service certification
                  </a>
                </li>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('environmental')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    ISO 14001:2015 Environmental system certification
                  </a>
                </li>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('safety')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    ISO 45001:2018 Safety system certification
                  </a>
                </li>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('information')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    ISO 27001:2022 Information security management system
                  </a>
                </li>
                <li className="px-6 py-3">
                  <a
                    onClick={() => setTab('quality')}
                    className="text-grey-600 hover:text-grey-800"
                  >
                    ISO 13485:2016 Quality system certification
                  </a>
                </li>
              </ul>
            </ul>
          </aside>

          {tab === 'cookie' && <Cookie/>}
          
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Policy;
